import { INSTAGRAM_URL } from '../constants/external-links.js'
import { getSiteUrl } from './siteUrl.js'

/**
 * Marketing home URL to share (matches /, /en, /pt).
 * @param {string} language - 'en' | 'pt' | other
 */
export function getMarketingShareUrl (language) {
  if (typeof window !== 'undefined') {
    const origin = window.location.origin
    if (language === 'pt') return `${origin}/pt`
    if (language === 'en') return `${origin}/en`
    return `${origin}/`
  }
  const base = getSiteUrl()
  if (language === 'pt') return `${base}/pt`
  if (language === 'en') return `${base}/en`
  return `${base}/`
}

/**
 * @param {function} t - translation function
 * @param {string} language
 */
export function buildVivaSharePayload (t, language) {
  const url = getMarketingShareUrl(language)
  const title = t('common.brand.name')
  const phoneLine = `${t('common.contact.phoneLabel')}: ${t('common.contact.phone')}`
  const addressLine = `${t('common.contact.addressLabel')}: ${t('common.contact.address')}`
  const instagramLine = `${t('common.contact.instagramLabel')}: ${INSTAGRAM_URL}`

  // Clipboard: single block with site URL once.
  const clipboardText = [title, url, phoneLine, addressLine, instagramLine].join('\n')

  // Web Share API: brand + contact lines; site URL only via `url` (UA appends it once).
  const shareText = [title, phoneLine, addressLine, instagramLine].join('\n')

  return { title, url, shareText, clipboardText }
}
